import * as React from 'react';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import { localizations } from '../../localization/localization';
import { Control, Form, ModelState, Errors } from 'react-redux-form';
import { DialogPropsBase } from '../../common/props/commonFormProps';
import { DeletedReasonModel } from '../../common/models/CommonModels';
import FormItem from '../../components/forms/FormItem';
import { renderMultilineTextField } from '../../common/forms/FieldCreators';
import { momentToString } from '../../utils/dateUtilities';
import { connect } from 'react-redux';
import * as unitsApi from '../../api/unitsApi';
import { UnitModel, DeleteUnitReason } from '../UnitModels';
import * as companyApi from '../../api/companyApi'
import { RestrictedCompanyModel, DeleteReportProps } from '../../common/models/CommonModels';
import * as validators from '../../common/validators/formValidators'
import { renderErrorInfoText } from '../../common/forms/FieldCreators';
import * as settingsApi from '../../api/settingsApi';

const renderSelect = (props: any) => {
    return <Select style={{ minWidth: "160px" }} displayEmpty {...props}>{props.children}</Select>
}

type SubmitType = (values: any) => void;
type CancelType = () => void;

interface DeleteUnitDialogProps extends DialogPropsBase<SubmitType, CancelType> {
    unit: UnitModel,
    companyId: string;
}

type AllProps = DeleteUnitDialogProps & DeleteReportProps<DeleteUnitReason>;

interface DeleteUnitState {
    isPartnerTrackingAllowed: boolean;
    reasons: DeletedReasonModel[];
    candidates: RestrictedCompanyModel[];
}

class DeleteUnitDialog extends React.Component<AllProps, DeleteUnitState> {

    constructor(props: AllProps) {
        super(props);

        this.state = {
            isPartnerTrackingAllowed: false,
            reasons: [],
            candidates: [],
        };
    }

    public componentDidMount() {
        unitsApi.getDeletedReasons().then(data => {
            companyApi.getRestrictionCandidates().then(candidateData => {
                settingsApi.getCompanyData(this.props.companyId).then(companySettings => {
                    const partnerTracking: boolean = companySettings && companySettings.allowPartnerTracking || false;

                    this.setState({
                        reasons: data,
                        candidates: candidateData,
                        isPartnerTrackingAllowed: partnerTracking
                    });
                });
            });
        });
    }

    public render() {
        const { unit, isOpen } = this.props;

        return <Dialog maxWidth={"lg"} open={isOpen}>
            <Form model="deleteUnit" onSubmit={this.props.onSubmit}>
                <DialogTitle title={localizations.units.deleteTable.deleteUnit}>{localizations.units.deleteTable.deleteUnit}</DialogTitle>
                <DialogContent>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>{localizations.units.deleteTable.departure}</TableCell>
                                <TableCell>{localizations.units.deleteTable.arrival}</TableCell>
                                <TableCell>{localizations.units.deleteTable.pointOfDeparture}</TableCell>
                                <TableCell>{localizations.units.deleteTable.pointOfArrival}</TableCell>
                                <TableCell>{localizations.common.type}</TableCell>
                                <TableCell>{localizations.units.unitIdentifier}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell>{momentToString(unit.readyTime)}</TableCell>
                                <TableCell>{momentToString(unit.deliveryTime)}</TableCell>
                                <TableCell>{unit.departureCity.name}</TableCell>
                                <TableCell>{unit.destinationCity.name}</TableCell>
                                <TableCell>{localizations.unitTypes[unit.trailerType]}</TableCell>
                                <TableCell>{unit.trailerIdentifier}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                    {/* </Grid> */}
                    <FormItem>
                        <FormControl >
                            <InputLabel key="reason-select">{localizations.common.reason}</InputLabel>
                            <Control.select model=".reason" validators={{ required: validators.required }} component={renderSelect} id="reason-select" value={this.props.selectedReason}>
                                {this.state.reasons.map(item => <MenuItem key={item.id} value={DeleteUnitReason[item.name]}>{localizations.units.deleteReasons[item.name]}</MenuItem>)}
                            </Control.select>
                            <Errors
                                model=".reason"
                                messages={{
                                    required: localizations.validation.required
                                }}
                                show={{ touched: true, focus: false }}
                                wrapper={renderErrorInfoText}
                            />
                        </FormControl>
                    </FormItem>
                    {this.props.selectedReason === DeleteUnitReason.FoundTruckForUnitFromThisApp && this.state.isPartnerTrackingAllowed ? <FormItem>
                        <FormControl style={{ minWidth: 120 }}>
                            <InputLabel key="reason-select">{localizations.company.company}</InputLabel>
                            <Control.select validators={{ required: validators.notUndefined }} validateOn={["blur", "change"]} model=".contractCompanyId" component={renderSelect} id="reason-contractCompanyId" value={this.props.candidate}>
                                {this.state.candidates.map(item => <MenuItem key={item.name} value={item.id}>{[item.name]}</MenuItem>)}
                            </Control.select>
                        </FormControl>
                        <Errors model={".contractCompanyId"} show={{ touched: true, focus: false }} messages={{ required: localizations.validation.required }} wrapper={renderErrorInfoText} />
                    </FormItem> : null}
                    <FormItem>
                        <Control.text id="reason-description" model=".deleteDescription" component={renderMultilineTextField} label={localizations.actions.describeDeleteReason} />
                    </FormItem>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="primary" onClick={this.props.onCancel}>{localizations.actions.cancel}</Button>
                    <Button variant="contained" color="secondary" type="submit">{localizations.actions.delete}</Button>
                </DialogActions>
            </Form>
        </Dialog>
    }
}

const mapStateToProps = ({ deleteUnit }: ModelState) => {
    return {
        selectedReason: deleteUnit.reason,
        candidate: deleteUnit.contractCompanyId
    }
}

export default connect<any, any, any>(mapStateToProps)(DeleteUnitDialog);


// WEBPACK FOOTER //
// ./src/units/forms/DeleteUnitDialog.tsx